<template>
  <div class="active-dark main-dark-page">
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Slider Area -->
    <div class="slider-wrapper">
      <SliderOne></SliderOne>
    </div>
    <!-- End Slider Area -->

    <!-- Start Brand Area -->
    <div class="rn-brand-area ptb--80 bg_color--6">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title mb--30">
              <span class="subtitle">Principais clientes</span>
              <h2 class="heading-title">Transformando negócios através da tecnologia.</h2>
            </div>
          </v-col>
        </v-row>
        <Brand />
      </v-container>
    </div>
    <!-- End Brand Area -->

    <!-- Start Portfolio Area -->
    <div class="portfolio-area ptb--80 bg_color--6 darker-portfolio-bg" id="portfolio">
      <div class="portfolio-wrapper">
        <v-container>
          <v-row>
            <v-col lg="12">
              <div class="text-center section-title">
                <span class="subtitle">Projetos em destaque</span>
                <h2 class="heading-title">Resultados que geram impacto</h2>
                <p class="description">
                  Casos reais que aumentaram eficiência e escalaram operações.
                </p>
              </div>
            </v-col>
          </v-row>
          <Portfolio />
        </v-container>
      </div>
    </div>
    <!-- End Portfolio Area -->

       <!-- Start Service Area -->
       <div id="service" class="service-area ptb--80 bg_color--5">
      <v-container>
        <v-row class="mb--30">
          <v-col cols="12">
            <div class="text-center section-title">
              <span class="subtitle">Sistemas, apps e integrações pensados para o seu negócio.</span>
              <h2 class="heading-title">Soluções Empresariais.</h2>
              <p class="description">
                Serviços sob medida, pensados para acelerar seu negócio com tecnologia.
              </p>
            </div>
          </v-col>
        </v-row>
        <ServiceTwo />
      </v-container>
    </div>
    <!-- End Service Area -->

    <!-- Start Testimonial Area  -->
    <div class="rn-testimonial-area bg_color--6 ptb--80">
      <v-container>
        <v-row class="mb--30">
          <v-col cols="12">
            <div class="text-center section-title">
              <span class="subtitle">Depoimentos</span>
              <h2 class="heading-title">O que dizem nossos clientes</h2>
            </div>
          </v-col>
        </v-row>
        <Testimonial />
      </v-container>
    </div>
    <!-- Start Testimonial Area  -->

    <!-- Start Counterup Area -->
    <div class="rn-counterup-area ptb--80 bg_color--5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title">
              <span class="subtitle">Resultados</span>
              <h2 class="heading-title">Nossa trajetória em números</h2>
              <p class="description">
                Evolução consistente impulsionada por entregas rápidas e de qualidade.
              </p>
            </div>
          </v-col>
        </v-row>

        <CounterOne />
      </v-container>
    </div>
    <!-- End Counterup Area -->

    <!-- Start About Area -->
    <div id="about" class="about-area ptb--80 bg_color--6">
      <div class="about-wrapper">
        <About>
          <img
            slot="thum-img"
            class="w-100"
            src="/socios.webp"
            alt="Sócios"
          />
        </About>
      </div>
    </div>
    <!-- End About Area -->

 



    <!-- Start Blog Area  -->
    <!-- <div class="rn-blog-area ptb--80 bg_color--5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title">
              <span class="subtitle">Conteúdo para decisores</span>
              <h2 class="heading-title">Quando escolher um sistema sob medida</h2>
              <p class="description">
                Notícias e análises que mostram quando o software próprio reduz custos e aumenta a eficiência.
              </p>
            </div>
          </v-col>
        </v-row>
        <Blog />
      </v-container>
    </div> -->
    <!-- End Blog Area  -->

    <div class="rn-contact-top-area ptb--80" id="contact">
       <v-container>
         <div class="text-center section-title mb--30">
           <span class="subtitle">Entre em contato</span>
           <h2 class="heading-title">Informações de contato</h2>
           <p class="description">
             Estamos aqui para ajudar você a crescer sua empresa com tecnologia.
           </p>
         </div>
         <div class="contact-glass">
           <ContactAddress />
         </div>
       </v-container>
     </div>

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>

<script>
  import Header from "../../components/header/Header";
  import SliderOne from "../../components/slider/SliderOne";
  import About from "../../components/about/About";
  import ServiceTwo from "../../components/service/ServiceTwo";
  import Portfolio from "../../components/portfolio/Portfolio";
  import CounterOne from "../../components/counter/CounterOne";
  import Testimonial from "../../components/testimonial/Testimonial";
  import Blog from "../../components/blog/Blog";
  import Brand from "../../components/brand/Brand";
  import Footer from "../../components/footer/Footer";
  import ContactAddress from "../../components/contact/ContactAddress";
  import Contact from "../../components/contact/Contact";

  export default {
    components: {
      Header,
      SliderOne,
      About,
      ServiceTwo,
      Portfolio,
      CounterOne,
      Testimonial,
      Blog,
      Brand,
      Footer,
      ContactAddress,
      Contact,
    },
    data() {
      return {
        logo: "/logoCodetimeWhite.webp",
      };
    },
    mounted() {
      // Adiciona JSON-LD Schema.org WebSite
      this.addJsonLd();
    },
    methods: {
      addJsonLd() {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "@id": "https://codetime.com.br/#website",
          "name": "Codetime Sistemas",
          "alternateName": "Codetime",
          "url": "https://codetime.com.br",
          "description": "Empresa de desenvolvimento de Sistemas e Aplicativos personalizado em Itajaí, SC. Especializada em ERP, aplicativos, integrações e automação para empresas.",
          "publisher": {
            "@type": "Organization",
            "@id": "https://codetime.com.br/#organization",
            "name": "Codetime Sistemas",
            "logo": {
              "@type": "ImageObject",
              "url": "https://codetime.com.br/logoCodetimeWhite.webp"
            }
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "https://codetime.com.br/?s={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          },
          "sameAs": [
            "https://www.instagram.com/codetime_sistemas/",
            "https://www.linkedin.com/company/codetime-sistemas",
            "https://maps.app.goo.gl/c9fW8Q9jdct8iYG56"
          ]
        });
        document.head.appendChild(script);
      }
    },
  };
</script>

<style lang="scss">

  .default-header .logo img {
    max-height: 30px; /* 34px * 0.9 */
  }
  
  // Slider bg
  .main-dark-page .slider-wrapper {
    position: relative;
    background: linear-gradient(160deg, #08090d 0%, #0a0b12 40%, #0a0f18 100%);
    overflow: hidden;
  }
  .main-dark-page .slider-wrapper::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(700px 360px at 20% 20%, rgba(0, 140, 247, 0.12), transparent 62%),
      radial-gradient(680px 360px at 80% 70%, rgba(249, 93, 129, 0.10), transparent 64%);
    pointer-events: none;
    z-index: 0;
  }

  // Brand bg
  /* Revertido: usar a cor padrão do tema via bg_color--6 (sem override específico aqui) */

  // Fundo mais escuro específico da seção de Portfolio nesta página
  .main-dark-page .darker-portfolio-bg {
    position: relative;
    background: linear-gradient(160deg, #0a0b10 0%, #0b0f1a 40%, #0a0f18 100%);
    overflow: hidden;
  }
  .main-dark-page .darker-portfolio-bg::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(520px 260px at 25% 30%, rgba(0, 140, 247, 0.10), transparent 62%),
      radial-gradient(520px 260px at 75% 70%, rgba(249, 93, 129, 0.10), transparent 62%);
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .darker-portfolio-bg > .portfolio-wrapper, 
  .main-dark-page .darker-portfolio-bg > .v-container { position: relative; z-index: 1; }

  .main-dark-page .theme-gradient {
    /* Ajuste sutil: levemente mais azul, mantendo o "shape" do original */
    background: linear-gradient(120deg, #008CF7 22%, #7644FF 50%, #F95D81 78%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
  }

  /* Fundo sutil com radial gradients apenas na seção About desta página */

  /* Fundo futurista para a seção de Serviços */
  .main-dark-page .service-area {
    position: relative;
    background: linear-gradient(160deg, #0a0b10 0%, #0e1220 45%, #0a1424 100%);
    overflow: hidden;
  }
  .main-dark-page .service-area::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(600px 320px at 15% 25%, rgba(0, 140, 247, 0.16), transparent 60%),
      radial-gradient(760px 420px at 85% 70%, rgba(249, 93, 129, 0.15), transparent 65%),
      radial-gradient(520px 300px at 70% 20%, rgba(118, 68, 255, 0.14), transparent 62%);
    filter: saturate(1.05);
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .service-area::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      repeating-linear-gradient(135deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 10px);
    mix-blend-mode: overlay;
    opacity: 0.14;
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .service-area > .v-container,
  .main-dark-page .service-area .section-title,
  .main-dark-page .service-area .service-wrapper { position: relative; z-index: 1; }

  .main-dark-page .rn-contact-top-area {
    position: relative;
    background: linear-gradient(160deg, #0d0f15 0%, #11141a 45%, #0f1620 100%);
    overflow: hidden;
  }
  .main-dark-page .rn-contact-top-area::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(600px 320px at 20% 25%, rgba(0, 140, 247, 0.18), transparent 60%),
      radial-gradient(720px 380px at 80% 75%, rgba(249, 93, 129, 0.16), transparent 62%),
      radial-gradient(540px 280px at 50% 50%, rgba(118, 68, 255, 0.14), transparent 65%);
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .rn-contact-top-area > .v-container { position: relative; z-index: 1; }

  /* Counter bg */
  .main-dark-page .rn-counterup-area {
    position: relative;
    background: linear-gradient(160deg, #0b0c12 0%, #0c0f18 50%, #0b101a 100%);
    overflow: hidden;
  }
  .main-dark-page .rn-counterup-area::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(520px 260px at 75% 25%, rgba(249, 93, 129, 0.12), transparent 60%),
      radial-gradient(520px 260px at 25% 75%, rgba(118, 68, 255, 0.10), transparent 62%);
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .rn-counterup-area > .v-container { position: relative; z-index: 1; }

  /* Contact bg + glass */
  .main-dark-page .rn-contact-top-area {
    position: relative;
    background: linear-gradient(160deg, #0a0b10 0%, #0e1220 45%, #0a1424 100%);
    overflow: hidden;
  }
  .main-dark-page .rn-contact-top-area::before {
    content: "";
    position: absolute;
    inset: -10% -10% -10% -10%;
    background:
      radial-gradient(600px 320px at 15% 25%, rgba(0, 140, 247, 0.12), transparent 60%),
      radial-gradient(760px 420px at 85% 70%, rgba(249, 93, 129, 0.10), transparent 65%),
      radial-gradient(520px 300px at 70% 20%, rgba(118, 68, 255, 0.08), transparent 62%);
    filter: saturate(1.02);
    pointer-events: none;
    z-index: 0;
  }
  .main-dark-page .rn-contact-top-area > .v-container { position: relative; z-index: 1; }

  // .main-dark-page .contact-glass {
  //   background: rgba(255, 255, 255, 0.05);
  //   border: 1px solid rgba(255, 255, 255, 0.10);
  //   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  //   border-radius: 16px;
  //   padding: 24px;
  //   backdrop-filter: blur(8px);
  //   -webkit-backdrop-filter: blur(8px);
  // }
</style>
